import { useState } from "react"
import PropTypes from "prop-types"
import { Tooltip, Box } from "@planningcenter/tapestry-react"
import { Checkbox } from "components/ui"

const WaitlistField = ({ selectionType, signup, onChange, disabled, disabledReason }) => {
  const [waitlistEnabled, setWaitlistEnabled] = useState(selectionType.waitlist || false)

  const handleChange = e => {
    setWaitlistEnabled(e.target.checked)
    return onChange({
      id: selectionType.id,
      waitlist: e.target.checked
    })
  }

  const unlimitedCapacity =
    selectionType.maximumCapacity === null && signup.maximumCapacity === null

  const disableInput =
    disabled ||
    selectionType.waitlistAttendeesCount > 0 ||
    (!selectionType.waitlist && unlimitedCapacity)

  let tooltip = ""

  if (disabled) {
    tooltip = disabledReason
  } else if (selectionType.waitlistAttendeesCount > 0) {
    tooltip = "Waitlist can't be turned off while there are attendees on the waitlist"
  } else if (!selectionType.waitlist && unlimitedCapacity) {
    tooltip = "Waitlist is only available if a capacity has been set."
  }

  return (
    <Tooltip placement="top" title={tooltip}>
      <Box>
        <Checkbox
          name="waitlist"
          htmlFor={`waitlist-${selectionType.id}`}
          text="Waitlist"
          checked={waitlistEnabled}
          value={selectionType.id.toString()}
          disabled={disableInput}
          onSelect={handleChange}
          wrapperClasses="mb-0"
          data={{ "data-pendo": "enable_waitlist_toggle" }}
        />
      </Box>
    </Tooltip>
  )
}

WaitlistField.propTypes = {
  selectionType: PropTypes.shape({
    id: PropTypes.number,
    waitlist: PropTypes.bool,
    waitlistAttendeesCount: PropTypes.number,
    maximumCapacity: PropTypes.number
  }),
  signup: PropTypes.shape({
    maximumCapacity: PropTypes.number
  }),
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  disabledReason: PropTypes.string
}

export default WaitlistField
